import axios from "axios";
import { loginUrl, relationshipManagerLoginUrl } from "../utils/urls";
export const AuthService = {
  login(data) {
    const response = axios.post(`${loginUrl}`, data);
    return response;
  },
  adminLogin(email, password) {
    return new Promise((resolve, reject) => {
      axios.post(`${loginUrl}`, { email, password }).then((response) => {
        resolve({
          status: true,
          data: response.data,
        });
      }).catch((error) => {
        reject({
          status: false,
          data: error?.response?.data || error?.response || error,
        });
      })
    })
  },
  relationshipManagerLogin(email, password) {
    return new Promise((resolve, reject) => {
      axios.post(`${relationshipManagerLoginUrl}`, { email, password }).then((response) => {
        resolve({
          status: true,
          data: response.data,
        });
      }).catch((error) => {
        reject({
          status: false,
          data: error?.response?.data || error?.response || error,
        });
      })
    })
  },
};
